import { useMemo, useState } from 'react';
import sampleSize from 'lodash/sampleSize';
import { useSelector } from 'src/client/redux';
import { useFeatureFlags } from 'src/client/helpers/useFeatureFlags';
import { usePromotions } from 'src/client/helpers/usePromotions';
import {
  AlsScan,
  Domai,
  EroticBeauty,
  ErroticaArchives,
  EternalDesire,
  GoddessNudes,
  LoveHairy,
  MetArt,
  MetArtX,
  PlayBoyPlus,
  RylskyArt,
  SexArt,
  Site,
  Straplez,
  Stunning18,
  TheLifeErotic,
  VivThomas,
  Vixen,
} from 'src/client/constants/sites';

const activeSites: Site[] = [
  MetArt,
  SexArt,
  AlsScan,
  Domai,
  ErroticaArchives,
  EroticBeauty,
  GoddessNudes,
  LoveHairy,
  MetArtX,
  TheLifeErotic,
  VivThomas,
  Straplez,
];

const optionalSites: Site[] = [EternalDesire, RylskyArt, Stunning18, Vixen, PlayBoyPlus];

export const useGateway = () => {
  const { user } = useSelector((state) => state.auth);
  const { cdnUrl } = useSelector((state) => state.app);
  const featureFlags = useFeatureFlags();
  const { isPromoGatewayActive, getPromoImage } = usePromotions();

  const [selectedSites, setSelectedSites] = useState<string[]>([]);
  const [backgroundImage, setBackgroundImage] = useState('');

  const backgroundImagePath = isPromoGatewayActive ? getPromoImage(['gateway']) : `${cdnUrl}/gateway/backgrounds`;

  const sitesToShow = useMemo(() => {
    const sites: string[] = [];
    if (featureFlags.showVixenInGateway && featureFlags.showVixenInUpgrades) {
      sites.push('vixen');
    }

    if (featureFlags.showPlayboyInGateway && featureFlags.showPlayboyInUpgrades) {
      sites.push('playboyplus');
    }
    const activeSubs = user?.subscriptions.map((sub) => sub.abbreviation) || [];
    const availableSites = activeSites.filter((site) => !activeSubs.includes(site.abbreviation));
    const additionalSites = sites
      .map((site) => optionalSites.find((s) => s.abbreviation === site))
      .filter(Boolean) as Site[];
    // @TODO This will be removed when all the sites come from man-site.
    // Randomize the sites, with the addition of any optional sites, and slice to length.
    const shuffled = sampleSize([...availableSites, ...additionalSites], 3);

    setSelectedSites(shuffled.map((site) => site.abbreviation));
    setBackgroundImage(`${backgroundImagePath}/${shuffled[0].abbreviation}_bg.jpg`);
    return shuffled;
  }, [backgroundImagePath, featureFlags, user?.subscriptions]);

  return {
    backgroundImage,
    backgroundImagePath,
    selectedSites,
    setBackgroundImage,
    setSelectedSites,
    sitesToShow,
  };
};
